import searchPlansTemplate from './searchPlans.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '=',
      searchType: '@'
    },
    template: searchPlansTemplate,
    controller: 'searchPlansController'
  };
}

function searchPlansController(
  $scope,
  $state,
  $log,
  $q,
  $transitions,
  companyService,
  platformService,
  siteService
) {
  // ////////////////////////
  // Value Initialization //
  // ////////////////////////

  const ctrl = this;

  $scope.state = $state;
  $scope.initialized = false;

  $scope.tabs = {
    sections: {
      filter: $scope.filterSet.getFilter('sections'),
      pitchFilter: $scope.filterSet.getFilter('limitToPitches')
    },
    platforms: {
      filter: $scope.filterSet.getFilter('platforms'),
      pitchFilter: $scope.filterSet.getFilter('pitchStatus')
    }
  };

  $scope.plansCollection = angular.copy($scope.searchType);

  $scope.missingData = {
    selectedHierarchy: false,
    websites: false,
    websiteSections: false
  };

  $scope.selectedPlatform = {};
  $scope.selectedSections = [];
  $scope.selectedWebsites = [];
  $scope.websites = [];

  ctrl.initializeData = () => {
    $q.all([
      companyService.get(),
      siteService.getWebsites(),
      siteService.getSections(ctrl.selectedWebsite._id)
    ])
      .then((response) => {
        $scope.websiteHierarchies = response[0].siteServiceHierarchies || [];
        $scope.websites = response[1];

        if ($scope.filterSet.getFilterValue('hierarchy')) {
          const hierarchyParams = $scope.filterSet.getFilterValue('hierarchy');
          $scope.selectedHierarchy = $scope.websites.find(site => site._id === hierarchyParams);
          if ($scope.selectedHierarchy) {
            ctrl.getNavigationWrapper($scope.selectedHierarchy._id, true);

            ctrl.getWebsitePlatforms($scope.selectedHierarchy._id);
          } else {
            $scope.missingData.selectedHierarchy = true;
          }

          if ($scope.filterSet.getFilterValue('websites')) {
            const websitesParams = $scope.filterSet.getFilterValue('websites');
            if (typeof websitesParams === 'string') {
              const selectedWebsite = $scope.websites.find(site => site._id === websitesParams);
              if (selectedWebsite) {
                $scope.selectedWebsites.push(selectedWebsite);
              }
            } else {
              const selectedWebsitesCopy = [];
              websitesParams.forEach((param) => {
                const selectedWebsite = $scope.websites.find(site => site._id === param);
                if (selectedWebsite) {
                  selectedWebsitesCopy.push(selectedWebsite);
                }
              });
              $scope.selectedWebsites = selectedWebsitesCopy;
            }
          }
        } else if (siteService.getSelectedWebsite()) {
          $scope.selectedHierarchy = siteService.getSelectedWebsite();
          ctrl.getNavigationWrapper($scope.selectedHierarchy._id, true);

          ctrl.getWebsitePlatforms($scope.selectedHierarchy._id);
        } else {
          siteService.getDefaultWebsite().then((website) => {
            $scope.selectedHierarchy = website;
            ctrl.getNavigationWrapper($scope.selectedHierarchy._id, true);

            ctrl.getWebsitePlatforms($scope.selectedHierarchy._id);
          });
        }

        $scope.currentFilter = $scope.tabs[$scope.searchType].filter;
        if ($scope.currentFilter.value) {
          ctrl.updatePills([].concat($scope.currentFilter.value));
        }

        if (
          $scope.currentFilter
          && $scope.currentFilter.param === 'pl'
          && $scope.currentFilter.value
        ) {
          ctrl.selectPlatformFromUrl();
        }
      }, () => {
        // TODO: Add in more general/different error handling during refactor in future ticket
        $log.error('Error getting websites data from site service');
        $scope.missingData.websites = true;
      });
  };

  ctrl.selectedWebsite = siteService.getSelectedWebsite();
  if (ctrl.selectedWebsite) {
    ctrl.initializeData();
  } else {
    siteService.getDefaultWebsite().then((res) => {
      ctrl.selectedWebsite = res;
      ctrl.initializeData();
    });
  }

  // ////////////////////////////////////
  // Multisite Platforms Functionality //
  // ////////////////////////////////////
  ctrl.getWebsitePlatforms = (id) => {
    $scope.websitePlatforms = platformService.getPlatformsByWebsiteId(id);
  };

  ctrl.selectPlatformFromUrl = () => {
    $scope.currentFilter = $scope.tabs[$scope.searchType].filter;
    const currentFilter = angular.copy($scope.currentFilter);

    const selectedPlatformArr = ($scope.selectedHierarchy || {})._id
      ? platformService.getPlatformsByPathAndWebsiteId(
        currentFilter.value, $scope.selectedHierarchy._id)
      : [];

    $scope.selectedPlatform = selectedPlatformArr && selectedPlatformArr.length ?
      selectedPlatformArr[0] : {};
  };

  // ////////////////////////////////////
  // Multisite Sections Functionality //
  // ////////////////////////////////////

  ctrl.getNavigationWrapper = (id, url = false) => {
    const website = $scope.websiteHierarchies.find(websiteObj => websiteObj.website === id);
    $scope.websiteHierarchy = website ? website.hierarchy : null;
    siteService.getNavigation(id, { hierarchy: $scope.websiteHierarchy }).then((response) => {
      $scope.websiteSections = response.children;
      $scope.initialized = true;

      if (
        url
        && $scope.currentFilter
        && $scope.currentFilter.param === 'sec'
        && $scope.currentFilter.value
      ) {
        ctrl.selectSectionsFromUrl();
      }
    }, () => {
      $log.error('Error getting website sections data from site service');
      $scope.missingData.websiteSections = true;
    });
  };

  ctrl.selectSectionsFromUrl = () => {
    $scope.currentFilter = $scope.tabs[$scope.searchType].filter;
    const currentFilter = angular.copy($scope.currentFilter);

    const paramsArr = typeof currentFilter.value === 'string' ? [currentFilter.value] : currentFilter.value;
    const matchingSections = siteService.getSectionsByPath(paramsArr);

    $scope.onChangeSelectedSections(matchingSections, false, false);
  };

  $scope.onChangeWebsites = (id, splice = true) => {
    const selectedWebsitesCopy = angular.copy($scope.selectedWebsites);
    const siteAlreadySelected = !!selectedWebsitesCopy.find(site => site._id === id);

    if (siteAlreadySelected && splice) {
      selectedWebsitesCopy.splice(selectedWebsitesCopy.findIndex(site => site._id === id), 1);
    } else if (!siteAlreadySelected) {
      const matchingSite = siteService.cache.websites.find(site => site._id === id);
      selectedWebsitesCopy.push(matchingSite);
    }

    $scope.selectedWebsites = selectedWebsitesCopy;

    const selectedWebsitesIds = $scope.selectedWebsites.map(site => site._id);
    $scope.filterSet.getFilter('websites').changeValue(selectedWebsitesIds);
  };

  $scope.onSelectHierarchy = (id) => {
    const matchingSite = siteService.cache.websites.find(site => site._id === id);

    if ($scope.missingData.selectedHierarchy) {
      $scope.missingData.selectedHierarchy = false;
    }

    $scope.selectedHierarchy = siteService.setSelectedWebsite(matchingSite);

    $scope.onChangeSelectedSections([], true);
    $scope.onChangeWebsites(id, false);

    ctrl.getNavigationWrapper(id);
    ctrl.getWebsitePlatforms(id);

    $scope.filterSet.getFilter('hierarchy').changeValue(id);
  };

  $scope.onChangeSelectedSections = (
    websiteSectionArr,
    removeOthers = false,
    updatePlans = true
  ) => {
    const selectedSectionsCopy = removeOthers ? [] : angular.copy($scope.selectedSections);

    websiteSectionArr.forEach((websiteSection) => {
      // Select
      if (
        selectedSectionsCopy.indexOf(websiteSection._id) === -1
        || removeOthers
      ) {
        selectedSectionsCopy.push(websiteSection._id);

      // Deselect
      } else if (selectedSectionsCopy.indexOf(websiteSection._id) > -1) {
        selectedSectionsCopy.splice(selectedSectionsCopy.indexOf(websiteSection._id), 1);
      }
    });

    $scope.selectedSections = selectedSectionsCopy;
    if (updatePlans) {
      // plans are already updated when user loads url with queryParams present
      $scope.updatePlans('sections', $scope.selectedSections);
    }
  };

  // //////////////////////////////////////////
  // Cross Sections-Platforms Functionality //
  // //////////////////////////////////////////

  ctrl.registerReset = (type, callback) => {
    $scope.tabs[type].reset = callback;
  };

  ctrl.updatePills = (value) => {
    switch ($scope.searchType) {
      case 'platforms':
        $scope.pills = ($scope.selectedHierarchy || {})._id
          ? platformService.getPlatformsByPathAndWebsiteId(value, $scope.selectedHierarchy._id)
          : [];
        break;
      case 'sections':
        $scope.pills = siteService.getSectionsByPath(value);
        break;
      default:
        $scope.pills = [];
    }
  };

  $scope.delete = (plan) => {
    $scope.$broadcast(`plan-panel: ${$scope.searchType}:delete'`, plan);

    $scope.pills = $scope.pills.filter(item => item.path !== plan.path);

    const paths = $scope.pills.map(pl => pl.path);

    if ($scope.searchType === 'sections') {
      $scope.onChangeSelectedSections([plan]);
    } else {
      $scope.updatePlans($scope.searchType, paths);
    }
  };

  $scope.selectPlan = (plan) => {
    if ($scope.searchType === 'platforms') {
      return false;
    }

    $scope.onChangeSelectedSections([plan], true);

    return true;
  };

  $scope.selectPlansCollection = (collection) => {
    $scope.plansCollection = collection;
  };

  $scope.updatePlans = (type, pathsArray, changeValueFilter = true) => {
    if (type !== $scope.searchType) {
      $scope.tabs[$scope.searchType].filter.changeValue(null);
      $scope.tabs[$scope.searchType].pitchFilter.changeValue(null);

      if (type === 'platforms' && $scope.searchType === 'sections') {
        $scope.onChangeSelectedSections([], true, false);
      } else if (type === 'sections' && $scope.searchType === 'platforms') {
        $scope.selectedPlatform = {};
      }

      $scope.searchType = type;
    }

    if (changeValueFilter) {
      $scope.tabs[type].filter.changeValue(pathsArray);
    }

    ctrl.updatePills(pathsArray);
  };

  // Functionality to update UI on transition change (e.g. back/forward buttons in browser)
  ctrl.searchUpdate = (transition) => {
    const transitionParams = transition.params();

    const arraysEqualFunc = (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = arr1.length; i >= 0; i -= 1) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    };

    if (transitionParams.hier && transitionParams.hier !== $scope.selectedHierarchy._id) {
      $scope.onSelectHierarchy(transitionParams.hier);
    }

    if (
      transitionParams.pl
      && $scope.selectedPlatform
      && (
        transitionParams.pl !== $scope.selectedPlatform.path
        || !$scope.selectedPlatform.path
      )
    ) {
      $scope.selectedPlatform = ($scope.selectedHierarchy || {})._id
        ? platformService.getPlatformsByPathAndWebsiteId(
          transitionParams.pl, $scope.selectedHierarchy._id)[0]
        : {};

      $scope.updatePlans('platforms', transitionParams.pl, false);
      $scope.selectPlansCollection('platforms');
    } else if (
      !transitionParams.pl
      && $scope.selectedPlatform
      && $scope.selectedPlatform.path
    ) {
      $scope.selectedPlatform = {};

      $scope.updatePlans('platforms', [], false);
    }

    if (transitionParams.sec) {
      const paramsArr = typeof transitionParams.sec === 'string' ? [transitionParams.sec] : transitionParams.sec;
      const arraysEqual = arraysEqualFunc(paramsArr, $scope.selectedSections);

      if (!arraysEqual) {
        const matchingSections = siteService.getSectionsByPath(paramsArr);
        $scope.onChangeSelectedSections(matchingSections, true, false);

        $scope.updatePlans('sections', paramsArr, false);
        $scope.selectPlansCollection('sections');
      }
    } else if (
      !transitionParams.sec
      && $scope.selectedSections
      && $scope.selectedSections.length
    ) {
      $scope.onChangeSelectedSections([], true, false);

      $scope.updatePlans('sections', [], false);
    }

    if (transitionParams.websites) {
      const paramsArr = typeof transitionParams.websites === 'string' ? [transitionParams.websites] : transitionParams.websites;

      const selectedWebsitesIds = $scope.selectedWebsites.map(site => site._id);

      const arraysEqual = arraysEqualFunc(paramsArr, selectedWebsitesIds);

      if (!arraysEqual) {
        const selectedWebsitesCopy = [];
        paramsArr.forEach((param) => {
          const selectedWebsite = $scope.websites.find(site => site._id === param);
          if (selectedWebsite) {
            selectedWebsitesCopy.push(selectedWebsite);
          }
        });
        $scope.selectedWebsites = selectedWebsitesCopy;
      }
    } else if (
      !transitionParams.websites
      && $scope.selectedWebsites
      && $scope.selectedWebsites.length
    ) {
      $scope.selectedWebsites = [];
    }
  };

  ctrl.transitionListener = $transitions.onSuccess({}, ctrl.searchUpdate.bind(ctrl));

  $scope.$on('$destroy', () => {
    ctrl.transitionListener();
  });
}

const ctrlArr = [
  '$scope',
  '$state',
  '$log',
  '$q',
  '$transitions',
  'companyService',
  'platformService',
  'siteService',
  searchPlansController
];

export default function (ngModule) {
  ngModule.directive('searchPlans', directive);
  ngModule.controller('searchPlansController', ctrlArr);
}
